import { apiPyAxios } from "../api/axios";

const unwrap = (res) => res.data?.results ?? res.data ?? [];

export const getLightShows = async ({ langId }, signal) => {
  const res = await apiPyAxios.get("light-shows/", {
    params: { lang: langId, page_size: 500 },
    signal,
  });

  const shows = unwrap(res);

  return shows.sort((a, b) => (a.priority || 0) - (b.priority || 0));
};